import changeCart from './changeCart';
import removeAddonLineItem from './removeAddonLineItem';

const renderMinicart = async () => {
  const minicartLineItemSelector = '[data-minicart-line-item]';

  const getLocalePrefix = () => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0] ?? '';
    return /^[a-z]{2}$/i.test(firstSegment) ? `/${firstSegment}` : '';
  };

  const getMinicartData = async () => {
    const localePrefix = getLocalePrefix();
    const url = `${window.location.origin}${localePrefix}/cart?view=minicart`;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.text();
    } catch (e) {
      console.error('Failed to fetch minicart:', e);
      return null;
    }
  };

  const setLineItemLoadingState = (el) => {
    el?.classList.add('opacity-50');
  };

  const bindMinicartEvents = (renderMinicartFn) => {
    const minicart = document.querySelector('[data-minicart]');
    if (!minicart) return;

    if (minicart.dataset.eventsBound === 'true') return;
    minicart.dataset.eventsBound = 'true';

    minicart.addEventListener('click', async (evt) => {
      const btn = evt.target.closest('[data-minicart-remove-item]');
      if (!btn) return;
      evt.preventDefault();
      btn.classList.add('pointer-events-none');

      const lineItemKey = btn.dataset.minicartRemoveItem;
      const lineItemEl = btn.closest(minicartLineItemSelector);
      setLineItemLoadingState(lineItemEl);
      await changeCart(lineItemKey, 0);
      await removeAddonLineItem(lineItemKey);
      await renderMinicartFn();
    });
  };

  const minicartContent = document.querySelector('[data-minicart-content]');
  const htmlText = await getMinicartData();
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, 'text/html');
  const minicartNewData = doc.querySelector('[data-minicart-render]');
  minicartContent.innerHTML = minicartNewData.innerHTML;

  bindMinicartEvents(renderMinicart);
};

export default renderMinicart;
